import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { create } from 'jss';
import rtl from 'jss-rtl';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { SnackbarProvider } from 'notistack';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import jssPreset from '@mui/styles/jssPreset';
import makeStyles from '@mui/styles/makeStyles';
import StylesProvider from '@mui/styles/StylesProvider';
import { LocalizationProvider } from '@mui/x-date-pickers';

import Auth from 'src/components/Auth';
import ScrollReset from 'src/components/ScrollReset';
import useSettings from 'src/hooks/useSettings';
import provideTheme from 'src/theme';
import Routes from 'src/Routes';
import { useIdleTimer } from 'react-idle-timer';
import { logout } from 'src/actions/accountActions';
import { useDispatch } from 'react-redux';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const useStyles = makeStyles(() => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%',
      width: '100%'
    },
    body: {
      height: '100%',
      width: '100%'
    },
    '#root': {
      height: '100%',
      width: '100%'
    }
  }
}));

function App() {
  useStyles();
  const dispatch = useDispatch();

  const { IDLE_TIMEOUT } = window.runtimeConfig;
  const timeout = (IDLE_TIMEOUT || 15) * 60 * 1000;

  useIdleTimer({
    timeout,
    onIdle: async function handleTimeout() {
      dispatch(logout());
    },
    debounce: 500,
  });

  const { settings } = useSettings();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={provideTheme(settings)}>
        <StylesProvider jss={jss}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <SnackbarProvider maxSnack={1}>
              <Router>
                <Auth>
                  <ScrollReset />
                  <Routes />
                </Auth>
              </Router>
            </SnackbarProvider>
          </LocalizationProvider>
        </StylesProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
